import React, { useMemo } from 'react';
import { useHighlightedScore } from './HighlightedScoreContext';

const PercentageBox: React.FC<{ correctPercentage: number | null; fontColor?: string }> =
  ({ correctPercentage, fontColor }) => {
    const { highThreshold, lowThreshold, getHighColor, getLowColor, getDefaultColor } =
      useHighlightedScore();

    const borderColor = useMemo(() => {
      if (correctPercentage === null) {
        return '#9E9E9E';
      }
      if (Number.isNaN(correctPercentage)) {
        return getDefaultColor();
      }
      if (correctPercentage >= highThreshold) {
        return getHighColor();
      }
      if (correctPercentage <= lowThreshold) {
        return getLowColor();
      }
      return getDefaultColor();
    }, [
      correctPercentage,
      highThreshold,
      lowThreshold,
      getHighColor,
      getLowColor,
      getDefaultColor,
    ]);

    return (
      <div
        style={{
          fontSize: '14px',
          fontWeight: 'bold',
          color: fontColor || '#333',
          minWidth: 'fit-content',
          textAlign: 'center',
          border: '2px solid',
          borderColor: borderColor,
          borderRadius: '4px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '1px 3px',
        }}
      >
        {correctPercentage === null || Number.isNaN(correctPercentage)
          ? '--'
          : `${Math.round(correctPercentage)}%`}
      </div>
    );
  };
export default PercentageBox;
